module.exports = __webpack_public_path__ + "static/media/track-midohio.d2129f6a.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/track-midohio.png
// module id = 1033
// module chunks = 0